import React from "react";
import { sectionHeader } from "../global.module.css";
import { OptionMaterial, Option } from "./option";
import * as Style from "./style.module.css";
import * as Global from "../global.module.css";

export default function Contact(props) {
  return (
    <section id="contact-me" className={Global.pageSectionContact}>
      <h1 className={sectionHeader} style={{ marginTop: "60px" }}>
        Contact Me
      </h1>
      <div className={Style.starHeader}>
        <div className={Style.starBar} style={{ marginRight: "10px" }}></div>
        <span className="material-icons" style={{ fontSize: "24pt" }}>
          star
        </span>
        <div className={Style.starBar} style={{ marginLeft: "10px" }}></div>
      </div>
      <div className={Style.container}>
        <Option
          fontClass="fas fa-envelope"
          text="EMAIL"
          url="mailto:sparkong02@gmail.com"
          urlText="Write to me!"
        />
        <Option
          fontClass="fab fa-linkedin"
          text="LINKEDIN"
          url="https://mx.linkedin.com/in/victor-alfonso-cortes-marquez"
          urlText="Connect with me!"
        />
        <Option
          fontClass="fab fa-twitter"
          text="TWITTER"
          url="https://twitter.com/sparking02"
          urlText="Follow me!"
        />
        <Option
          fontClass="fab fa-telegram-plane"
          text="TELEGRAM"
          url="https://t.me/VictorCortes95"
          urlText="Chat with me!"
        />
        <Option
          fontClass="fab fa-github"
          text="GITHUB"
          url="https://github.com/Sparking2"
          urlText="My Code"
        />
      </div>
    </section>
  );
}
